// extracted by mini-css-extract-plugin
export default {"activateLiveTitle":"lGOYBqo0vfW_UbcqZBc1","activateLiveDescription":"WHf0PpkLVJU4Wf45Orx8"};